import { render, staticRenderFns } from "./InputWidget.vue?vue&type=template&id=4a9dc2cc&scoped=true&"
import script from "./InputWidget.vue?vue&type=script&lang=js&"
export * from "./InputWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9dc2cc",
  null
  
)

export default component.exports